import { render, staticRenderFns } from "./ProjectListComponent.vue?vue&type=template&id=7568735e&scoped=true"
import script from "./ProjectListComponent.vue?vue&type=script&lang=js"
export * from "./ProjectListComponent.vue?vue&type=script&lang=js"
import style0 from "./ProjectListComponent.vue?vue&type=style&index=0&id=7568735e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7568735e",
  null
  
)

export default component.exports